/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultBroadcastExecutionResponse } from '../../models/api-response-paged-result-broadcast-execution-response';
import { PagedRequestVoid } from '../../models/paged-request-void';

export interface SearchBroadcastExecutions$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: PagedRequestVoid
}

export function searchBroadcastExecutions(http: HttpClient, rootUrl: string, params: SearchBroadcastExecutions$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultBroadcastExecutionResponse>> {
  const rb = new RequestBuilder(rootUrl, searchBroadcastExecutions.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultBroadcastExecutionResponse>;
    })
  );
}

searchBroadcastExecutions.PATH = '/v1/api/ui/broadcast/{reference}/executions/search';
